module.exports = __webpack_public_path__ + "static/media/SF-2-A (1).9bdf87d1.mp3";